module.exports = __webpack_public_path__ + "static/img/pin-trap-active-irregular.ad019a5.svg";